/**
 * <TutorHomeColumns> — la disposition de l'accueil du masteur : deux colonnes quand la place y est,
 * une pile sinon (maquette A1).
 *
 * **Ce que le masteur a à faire passe tout en haut** (Wajih, 29/10) : « À faire » ouvre l'accueil,
 * avant la séance qui vient. En deux colonnes : à gauche ce que la journée demande (« À faire »,
 * puis « Aujourd'hui »), à droite l'offre de cours, « Mon score » et le mois — la première rangée
 * porte donc les deux choses qui attendent une réponse. Sur un téléphone, tout s'empile : À faire,
 * Aujourd'hui, l'offre, Mon score, le mois — l'offre remonte sous la journée, parce qu'elle attend
 * une réponse. C'est le seul endroit où l'ordre dépend de la largeur ; il est écrit ici, une fois,
 * et le squelette passe par le même composant.
 *
 * Le seuil se lit sur la largeur de CE bloc (`useWidthAtLeast`), pas sur la fenêtre.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { useWidthAtLeast } from "../../hooks/useWidthAtLeast"

/** Deux colonnes à partir de cette largeur de BLOC — une fenêtre à `md` moins les marges. */
const TWO_COLUMNS_FROM = 760

export type TutorHomeColumnsProps = {
    today: React.ReactNode
    offer?: React.ReactNode
    todo?: React.ReactNode
    score?: React.ReactNode
    month?: React.ReactNode
}

export function TutorHomeColumns(props: TutorHomeColumnsProps) {
    const { today, offer, todo, score, month } = props
    const { onLayout, atLeast } = useWidthAtLeast(TWO_COLUMNS_FROM)
    const side = [offer, score, month].filter((block) => block != null && block !== false)

    if (atLeast && side.length > 0)
        return (
            <View onLayout={onLayout} style={styles.columns}>
                <View style={[styles.stack, styles.main]}>
                    {todo}
                    {today}
                </View>
                <View style={[styles.stack, styles.side]}>
                    {offer}
                    {score}
                    {month}
                </View>
            </View>
        )

    return (
        <View onLayout={onLayout} style={styles.stack}>
            {todo}
            {today}
            {offer}
            {score}
            {month}
        </View>
    )
}

const styles = StyleSheet.create((theme) => ({
    stack: { gap: theme.spacing["6"] },
    columns: { flexDirection: "row", alignItems: "flex-start", gap: theme.spacing["6"] },
    main: { flexGrow: 3, flexShrink: 1, flexBasis: 0, minWidth: 0 },
    side: { flexGrow: 2, flexShrink: 1, flexBasis: 0, minWidth: 0 },
}))
